import { Type } from '@sinclair/typebox';
import { priceSchema, shippingMethodPriceSchema } from "../price.mjs";
const deliveryEstimateSchema = Type.Object({
    formattedDate: Type.String(),
    minDate: Type.Number(),
    maxDate: Type.Number(),
});
export const shippingMethodSchema = Type.Object({
    id: Type.String(),
    name: Type.String(),
    title: Type.String(),
    type: Type.String(),
    price: shippingMethodPriceSchema,
    image: Type.Object({
        url: Type.String(),
        alt: Type.String(),
    }),
    deliveryEstimate: deliveryEstimateSchema,
});
const totalAmountForFreeShipping = Type.Object({
    normal: Type.Union([Type.Number(), Type.Null()]),
    fast: Type.Union([Type.Number(), Type.Null()]),
    express: Type.Union([Type.Number(), Type.Null()]),
});
export const checkoutPageShippingSchema = Type.Object({
    $type: Type.Literal('checkoutPage'),
    totalAmountForFreeShipping: Type.Optional(totalAmountForFreeShipping),
    shippingMethods: Type.Array(shippingMethodSchema),
    selectedShippingMethod: Type.Optional(shippingMethodSchema),
});
const shippingOption = Type.Object({
    id: Type.String(),
    name: Type.String(),
    title: Type.String(),
    type: Type.String(),
    price: Type.Object({
        total: priceSchema,
        delivery: priceSchema,
        handling: priceSchema,
    }),
    image: Type.Object({
        url: Type.String(),
        alt: Type.String(),
    }),
    deliveryEstimate: deliveryEstimateSchema,
});
export const shippingOptionsList = Type.Object({
    totalAmountForFreeShipping: Type.Union([totalAmountForFreeShipping, Type.Null()]),
    list: Type.Optional(Type.Array(shippingOption)),
});
export const cartShippingSchema = Type.Union([checkoutPageShippingSchema]);
//# sourceMappingURL=shipping.js.map